import { apis } from '../../../config';
import { api } from '../../../api/api';
import { ErrMsgCodeMap, ErrResult } from '../../../api/errMap';
class NetStorageShareImpl {
    constructor() {
        this.name = apis.netStorageShareImpl;
        this.http = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
        this.eventApi = api.getEventApi();
    }
    init() {
        return this.name;
    }
    async addNSCollaborator(req) {
        const { data } = await this.http.post(this.systemApi.getUrl('addNSCollaborator'), req, { contentType: 'json' });
        return {
            title: data.message,
            code: data.code,
        };
    }
    async deleteNSShare(recordId, forMe) {
        const url = !forMe ? 'deleteNSShare' : 'deleteNSShareWithMe';
        const { data } = await this.http.post(this.systemApi.getUrl(url), { recordId });
        return {
            title: data.message,
            code: data.code,
        };
    }
    async getNSShareLink(req) {
        const { data } = await this.http.get(this.systemApi.getUrl('getNSShareLink'), req);
        if (data === null || data === void 0 ? void 0 : data.success) {
            return {
                availableShareTypes: data.data.availableShareTypes,
                shareType: data.data.shareType,
                shareUrl: data.data.shareUrl,
            };
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async getNSExternalShareLink(req) {
        const { data } = await this.http.post(this.systemApi.getUrl('getNSExternalShareLink'), req, { contentType: 'json' });
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data;
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async getNSExternalShareStatistic(req) {
        const { data } = await this.http.get(this.systemApi.getUrl('getNSExternalShareStatistic'), req, { contentType: 'json' });
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data;
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async getNSExternalShareList(request) {
        const { data } = await this.http.post(this.systemApi.getUrl('getNSExternalShareList'), request, { contentType: 'json' });
        if (data === null || data === void 0 ? void 0 : data.success) {
            const shareData = data.data || {};
            shareData.shareDetails = shareData.shareDetails
                ? shareData.shareDetails.map((item) => {
                    const { linkDetail } = item;
                    delete item.linkDetail;
                    item = Object.assign(Object.assign({}, item), linkDetail);
                    return item;
                })
                : [];
            return shareData;
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async getNSExternalShareInteractDetail(req) {
        const { data } = await this.http.post(this.systemApi.getUrl('getNSExternalShareInteractDetail'), req, { contentType: 'json' });
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data;
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async modifyNSExternalShareLinkStatus(req) {
        const url = this.http.buildUrl(this.systemApi.getUrl('modifyNSExternalShareLinkStatus'), req);
        const { data } = await this.http.post(url, {}, { contentType: 'json' });
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data;
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async modifyNSExternalShareLink(req) {
        const url = this.systemApi.getUrl('modifyNSExternalShareLink');
        const { data } = await this.http.post(url, req, { contentType: 'json' });
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data;
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async listNSCollaborator(req) {
        const { data } = await this.http.get(this.systemApi.getUrl('listNSCollaborator'), req);
        if (data === null || data === void 0 ? void 0 : data.success) {
            return {
                page: data.data.page,
                pageSize: data.data.pageSize,
                totalCount: data.data.totalCount,
                collaborators: data.data.collaborators,
            };
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async listNSShare(req) {
        const url = !req.forMe ? 'listNSShare' : 'listNSShareWithMe';
        const { data } = await this.http.get(this.systemApi.getUrl(url), req);
        if (data === null || data === void 0 ? void 0 : data.success) {
            const resShareData = data;
            return {
                data: (resShareData.data ? resShareData.data : []).map(item => (Object.assign(Object.assign({}, item), { roleArr: (item === null || item === void 0 ? void 0 : item.roles) || [] }))),
                total: resShareData.total,
                page: resShareData.page,
                size: resShareData.size,
            };
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async removeNSCollaborator(req) {
        const { data } = await this.http.post(this.systemApi.getUrl('removeNSCollaborator'), req);
        return {
            title: data.message,
            code: data.code,
        };
    }
    async updateNSCollaborator(req) {
        const { data } = await this.http.post(this.systemApi.getUrl('updateNSCollaborator'), req, { contentType: 'json' });
        return {
            title: data.message,
            code: data.code,
        };
    }
    async updateNSShareType(req) {
        const { data } = await this.http.post(this.systemApi.getUrl('updateNSShareType'), req, { contentType: 'json' });
        return {
            title: data.message,
            code: data.code,
        };
    }
    async checkShareAuth(req) {
        const { data } = await this.http.post(this.systemApi.getUrl('checkShareAuth'), req);
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data;
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async getExtShareContentList(req) {
        const { data } = await this.http.post(this.systemApi.getUrl('checkShareAuth'), req);
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data;
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    getNSErrMsg(err) {
        if (err && err.code) {
            return this.getErrMsg(err.code);
        }
        return {
            code: err.code === undefined ? '' : err.code + '',
            title: ErrMsgCodeMap.UNKNOWN_ERR,
        };
    }
    getErrMsg(errMsg, defaultMsg) {
        if (errMsg) {
            const messageInfo = ErrResult[errMsg];
            if (messageInfo) {
                if ((messageInfo.popupType && messageInfo.popupType == 'window') || messageInfo.popupType == 'toast') {
                    this.eventApi.sendSysEvent({
                        eventName: 'error',
                        eventLevel: 'error',
                        eventStrData: '',
                        eventData: messageInfo,
                        eventSeq: 0,
                    });
                }
                return messageInfo;
            }
            if (errMsg in ErrMsgCodeMap) {
                return {
                    title: ErrMsgCodeMap[errMsg],
                    code: errMsg + '',
                };
            }
        }
        return {
            title: (errMsg ? errMsg + '' : undefined) || defaultMsg || ErrMsgCodeMap.UNKNOWN_ERR,
            code: 'UNKNOWN_ERR',
        };
    }
    async getCommonRequestResult(req, key, useGet) {
        const { data } = !useGet ? await this.http.post(this.systemApi.getUrl(key), req, { contentType: 'json' }) : await this.http.get(this.systemApi.getUrl(key), req);
        if (data === null || data === void 0 ? void 0 : data.success) {
            return data.data;
        }
        return Promise.reject(this.getNSErrMsg(data));
    }
    async addAnonymousShareContent(req) {
        return await this.getCommonRequestResult(req, 'addNSExtShare');
    }
    async checkAnonymousDirList(req) {
        const ret = await this.getCommonRequestResult(req, 'getNSExtDirContentList', true);
        return ret;
    }
    async checkAnonymousFileInfo(req) {
        const ret = await this.getCommonRequestResult(req, 'getNSExtFileContent', true);
        return ret;
    }
    async downloadAnonymousFileInfo(req) {
        const ret = await this.getCommonRequestResult(req, 'getNSExtFileDownload', true);
        return {
            content: ret,
            code: 'S_OK',
            title: '',
        };
    }
    async previewAnonymousFileInfo(req) {
        const ret = await this.getCommonRequestResult(req, 'getNSExtFilePreview', true);
        return {
            content: ret,
            code: 'S_OK',
            title: '',
        };
    }
}
const netStorageImpl = new NetStorageShareImpl();
api.registerLogicalApi(netStorageImpl);
export default netStorageImpl;
